import React from 'react';
import { createGate, useStore } from 'effector-react';
import { createEvent } from 'effector';
import type { LookToView } from '@types';
import Button from '@components/Button';
import { MainPlayer } from '@stores/krpPlayerStores';
import ImgBlock from './img-block.png';

const round = (val: number) => Math.round(val * 1000) / 1000;

export const groupViewCatpure = createEvent<LookToView>();
export const $GateGroupViewCapture = createGate({ defaultState: false });

export function GroupViewCaptureWidget() {
  const isOn = useStore($GateGroupViewCapture.state);
  if (!isOn) return null;

  return (
    <>
      <img
        src={ImgBlock}
        draggable={false}
        className="pointer-events-none absolute"
        style={{ width: 704, height: 404, zIndex: 2800 }}
        alt=""
      />
      <Button
        className="absolute mt-300"
        style={{ zIndex: 2800 }}
        onClick={() => {
          const view = MainPlayer.get()?.getView();
          if (!view) return;
          groupViewCatpure({
            fov: round(view.fov),
            hlookat: round(view.hlookat),
            vlookat: round(view.vlookat),
          });
        }}
      >
        把当前视角设为分组视角
      </Button>
    </>
  );
}
